import instance from '../axios'

const actorsApi = {
  getPopular: (page: number = 1) => {
    return instance.get(`/actors/popular`, { params: { page } })
  },
  getById: (id: number) => {
    return instance.get(`/actors/${id}`)
  },
}

export default actorsApi
